/**
 * BrandHeader — Header pubblico brandizzato riutilizzabile (R60.25).
 * Palette navy #12244A + gold #E8A63E, logo Sa.Gi ufficiale.
 */
import { Link } from "react-router-dom";
import { SaGiLogo } from "./Logos";

export default function BrandHeader({ variant = "light", showCta = true }) {
  const isDark = variant === "dark";
  return (
    <header
      className={`sticky top-0 z-40 ${
        isDark
          ? "bg-[#12244A]/95 backdrop-blur border-b border-[#1E3D6E]"
          : "bg-white/95 backdrop-blur border-b border-slate-200"
      }`}
      data-testid="brand-header"
    >
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-3 min-w-0" data-testid="brand-header-logo">
          <SaGiLogo size={44} />
          <div className="min-w-0 leading-tight">
            <p className={`text-[9px] uppercase tracking-[0.18em] font-bold ${isDark ? "text-[#F4C57C]" : "text-[#E8A63E]"}`}>
              Sa.Gi Group
            </p>
            <p className={`text-[15px] font-black tracking-tight ${isDark ? "text-white" : "text-[#12244A]"}`}>
              e-Log <span className="text-[#E8A63E]">HACCP</span>
            </p>
          </div>
        </Link>

        {showCta && (
          <div className="flex items-center gap-2">
            <Link
              to="/login"
              className={`hidden sm:inline-flex items-center h-9 px-4 rounded-lg text-[13px] font-bold border-2 transition ${
                isDark
                  ? "border-white/70 text-white hover:bg-white hover:text-[#12244A]"
                  : "border-[#12244A] text-[#12244A] hover:bg-[#12244A] hover:text-white"
              }`}
              data-testid="brand-header-accedi"
            >
              Accedi
            </Link>
            <Link
              to="/prova-gratis#attiva-demo"
              className="inline-flex items-center h-9 px-4 rounded-lg text-[13px] font-bold bg-[#E8A63E] hover:bg-[#D4941F] text-[#12244A] shadow-sm transition active:scale-95"
              data-testid="brand-header-cta"
            >
              Contattaci
            </Link>
          </div>
        )}
      </div>
    </header>
  );
}
